const drawerWidth = 260
const blackColor = '#000'
const hexToRgb = (input) => {
  input = input + ''
  input = input.replace('#', '')
  const hexRegex = /[0-9A-Fa-f]/g
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.')
  }
  if (input.length === 3) {
    const first = input[0]
    const second = input[1]
    const last = input[2]
    input = first + first + second + second + last + last
  }
  input = input.toUpperCase(input)
  const first = input[0] + input[1]
  const second = input[2] + input[3]
  const last = input[4] + input[5]
  return (
    parseInt(first, 16) +
    ', ' +
    parseInt(second, 16) +
    ', ' +
    parseInt(last, 16)
  )
}

const transition = {
  transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)',
}
const boxShadow = {
  boxShadow:
    '0 10px 30px -12px rgba(' +
    hexToRgb(blackColor) +
    ', 0.42), 0 4px 25px 0px rgba(' +
    hexToRgb(blackColor) +
    ', 0.12), 0 8px 10px -5px rgba(' +
    hexToRgb(blackColor) +
    ', 0.2)',
}
const defaultFont = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: '300',
  lineHeight: '1.5em',
}
const primaryColor = ['#014B96', '#13599e', '#06294c', '#2CA2C5', '#004BCE', '#2BCE75']
const primaryBoxShadow = {
  boxShadow:
    '0 4px 20px 0 rgba(' +
    hexToRgb(blackColor) +
    ',.14), 0 7px 10px -5px rgba(' +
    hexToRgb(primaryColor[0]) +
    ',.4)',
}
const infoColor = ['#014B96', '#205e9c', '#13599e', '#00d3ee']
const successColor = ['#1C8464', '#1C8464', '#125A44', '#2DBF64']
const warningColor = ['#ff9800', '#ffa726', '#fb8c00', '#ffa21a']
const dangerColor = ['#EE3228', '#EE3228', '#B6241C', '#f55a4e']

const whiteColor = '#FFF'
const grayColor = [
  '#999',
  '#777',
  '#3C4858',
  '#AAAAAA',
  '#D2D2D2',
  '#DDD',
  '#b4b4b4',
  '#555555',
  '#333',
  '#a9afbb',
  '#eee',
  '#e7e7e7',
]
const defaultBoxShadow = {
  border: '0',
  borderRadius: '3px',
  boxShadow:
    '0 10px 20px -12px rgba(' +
    hexToRgb(blackColor) +
    ', 0.42), 0 3px 20px 0px rgba(' +
    hexToRgb(blackColor) +
    ', 0.12), 0 8px 10px -5px rgba(' +
    hexToRgb(blackColor) +
    ', 0.2)',
  padding: '10px 0',
  transition: 'all 150ms ease 0s',
}

const container = {
  paddingRight: '15px',
  paddingLeft: '15px',
  marginRight: 'auto',
  marginLeft: 'auto',
}

const primaryCardHeader = {
  background:
    'linear-gradient(60deg, ' + primaryColor[1] + ', ' + primaryColor[2] + ')',
  // 'linear-gradient(60deg, #ffffff, #ffffff)',
  border: '1px solid',
  // color: 'black',
  // ...primaryBoxShadow,
}

const successCardHeader = {
  background:
    'linear-gradient(60deg, ' + primaryColor[2] + ', ' + primaryColor[2] + ')',
  border: '1px solid',
  // color: 'black',
  // ...primaryBoxShadow,
}

const primaryGradient = {
  background:
    'linear-gradient(135deg,' + primaryColor[4] + '11%,' + primaryColor[5] + '100%)',
}

export {
  hexToRgb,
  drawerWidth,
  transition,
  container,
  boxShadow,
  defaultFont,
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  grayColor,
  blackColor,
  whiteColor,
  primaryBoxShadow,
  defaultBoxShadow,
  primaryCardHeader,
  successCardHeader,
  primaryGradient
}
